import React from 'react';

const defaultOptions = {
  loading: () => <div style={{display: 'flex', width: '100%'}}/>,
};

export {
  defaultOptions,
};
